import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ISubscriptionStatus } from '../../../entity/interface/iSubscriptionStatus';
import { IUserIdentityRepository } from '../../repositories/interfaces/iUserIdentityRepository';
import InitiatedError from '../../entities/errors/InitiatedError';

export interface IGetSubscriptionStatusUseCase {
    execute(apiKey: string, username: string, token: string, identityToken: string): Promise<ISubscriptionStatus>;
}

export class GetSubscriptionStatusUseCase implements IGetSubscriptionStatusUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userIdentityRepository(): IUserIdentityRepository {
        return container.resolve<IUserIdentityRepository>(DI.REPOSITORIES.IDeviceRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        username: string,
        token: string,
        identityToken: string
    ): Promise<ISubscriptionStatus> {
        const response = await this.userIdentityRepository.getSubscriptionStatus(
            apiKey,
            username,
            token,
            identityToken
        );
        if (response.data?.identityToken) {
            return response.data;
        } else {
            throw new InitiatedError(
                'MISSING_USER_AUTHENTICATION',
                'Missing user authentication details from API response'
            );
        }
    }
}
